import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsTableComponent } from './reports-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { ReportsTableRoutingModule } from './reports-table-routing.module';
import { ChSkeletonComponent } from '../../../shared/ch-skeleton/ch-skeleton.component';



@NgModule({
  declarations: [
    ReportsTableComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    MaterialModule,
    CustomTimpickerModule,
    CustomInputModule,
    MatPaginatorModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    ExpansionPanelModule,
    ReportsTableRoutingModule,
    ChSkeletonComponent
],
  exports:[
    ReportsTableComponent
  ]
})
export class ReportsTableModule { }
